(function() {
  'use strict';

  function initMobileThumbs() {
    var thumbsContainer = document.querySelector('[data-mobile-thumbs]');
    if (!thumbsContainer) return;

    var carousel = document.querySelector('.product__media-container.below-mobile.carousel');
    if (!carousel) return;

    var thumbSlides = thumbsContainer.querySelectorAll('.product__mobile-thumb-slide');
    if (!thumbSlides.length) return;

    // Set first thumb as active
    thumbSlides[0].classList.add('is-active');

    // Click handler for thumbnails
    thumbSlides.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        // Find the Swiper instance on the carousel
        var swiper = carousel.swiper;
        if (swiper) {
          swiper.slideTo(index);
        }

        // Update active thumb
        thumbSlides.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Watch for Swiper slide changes to sync thumb highlights
    var observer = new MutationObserver(function() {
      var swiper = carousel.swiper;
      if (!swiper) return;

      // Only attach the event once
      if (!carousel.dataset.thumbsSynced) {
        carousel.dataset.thumbsSynced = 'true';
        swiper.on('slideChange', function() {
          var activeIndex = swiper.realIndex;
          thumbSlides.forEach(function(t) { t.classList.remove('is-active'); });
          if (thumbSlides[activeIndex]) {
            thumbSlides[activeIndex].classList.add('is-active');

            // Scroll the active thumb into view
            thumbSlides[activeIndex].scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        });
      }
    });

    // Observe for Swiper initialization (it adds classes dynamically)
    observer.observe(carousel, { attributes: true, attributeFilter: ['class'] });

    // Also try direct attachment in case Swiper is already initialized
    var checkSwiper = setInterval(function() {
      var swiper = carousel.swiper;
      if (swiper && !carousel.dataset.thumbsSynced) {
        carousel.dataset.thumbsSynced = 'true';
        clearInterval(checkSwiper);

        swiper.on('slideChange', function() {
          var activeIndex = swiper.realIndex;
          thumbSlides.forEach(function(t) { t.classList.remove('is-active'); });
          if (thumbSlides[activeIndex]) {
            thumbSlides[activeIndex].classList.add('is-active');
            thumbSlides[activeIndex].scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        });
      }
    }, 200);

    // Stop polling after 10 seconds
    setTimeout(function() { clearInterval(checkSwiper); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileThumbs);
  } else {
    initMobileThumbs();
  }
})();
